<div class="advert__intro">
    @if (adLogo()) {
        <img class="advert__logo img-fluid" [src]="adLogo()" />
    }
    <div class="advert__title">{{ adTitle() }}</div>
    <p class="advert__text text-body-secondary mb-0">
        {{ adContent() }}
    </p>
    <div>
        <ng-content />
    </div>
</div>
<div class="d-block">
    <div class="advert__items">
        <ng-content select="sf-advert-cta-item"></ng-content>
    </div>
</div>
